import { render, staticRenderFns } from "./TrackTaskList.vue?vue&type=template&id=3b1272e2&"
import script from "./TrackTaskList.vue?vue&type=script&lang=js&"
export * from "./TrackTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports